import { showSnackbar } from "utils/snack_bar/store/action";
import { Logout } from "../graphql/mutation";
import { actionTypes, LogOutProps } from "./actionType";
import { executeMutation } from "utils/services/apiServices";

export const LogoutRequest = () => ({
  type: actionTypes.LOGOUT_REQUEST,
});
export const LogoutSuccess = (payload:string) => ({
  type: actionTypes.LOGOUT_SUCCESS,
  payload
});

export const LogoutFail = (payload: string) => ({
  type: actionTypes.LOGOUT_FAIL,
  payload,
});

export const authLogout = () => {
  return async (dispatch: any) => {
    try {
      dispatch(LogoutRequest());
      const response = await executeMutation(Logout,{});
      const jsonData = response.data?.logout;
      if (jsonData?.error) {
        const errorMessage = jsonData.error.message;
        dispatch(LogoutFail(errorMessage));
        dispatch(showSnackbar(`Error: ${errorMessage}`));
        return;
      }
      dispatch(LogoutSuccess(jsonData.data.message));
       dispatch(showSnackbar(jsonData.data.message));
    } catch (error: any) {
      dispatch(LogoutFail("Something went wrong"));
    }
  };
};
